// Shared classes for the Teams page (Figma "Teams" Usage, 10827:11147).

export const teamsOutlinePillClassName =
  'inline-flex h-10 shrink-0 items-center justify-center gap-2 rounded-full border border-grey-100 bg-true-white px-4 text-sm font-medium leading-body transition-colors hover:bg-grey-50 disabled:cursor-not-allowed disabled:opacity-50 dark:border-border dark:bg-card dark:hover:bg-muted';

export const teamsOutlineCardButtonClassName =
  'inline-flex h-10 shrink-0 items-center justify-center gap-2 rounded-card border border-grey-100 bg-true-white px-4 text-sm font-medium leading-body transition-colors hover:bg-grey-50 disabled:cursor-not-allowed disabled:opacity-50 dark:border-border dark:bg-card dark:hover:bg-muted';

export const teamsFilterChipClassName =
  'inline-flex h-10 shrink-0 items-center gap-2 rounded-card border px-4 text-sm font-medium leading-body transition-colors';

export const teamsFilterChipActiveClassName =
  'border-grey-900 bg-grey-900 text-true-white';

export const teamsFilterChipIdleClassName =
  'border-grey-100 bg-true-white text-grey-900 hover:bg-grey-50 dark:border-border dark:bg-card dark:text-foreground dark:hover:bg-muted';

export const teamsTableShellClassName =
  'overflow-hidden rounded-section border border-grey-100 bg-true-white dark:border-border dark:bg-card';

/** Match IAM DataTable header (#f5f5f5 / #2a2a2a) via tokens. */
export const teamsTableHeaderRowClassName = 'border-b bg-grey-50 dark:bg-muted';

/** Match IAM DataTable row hover (light tint / white 5%). */
export const teamsTableBodyRowClassName =
  'border-b last:border-b-0 transition-colors hover:bg-grey-50 dark:hover:bg-sidebar-pill-dark';

export const teamsStatusBadgeClassName =
  'shrink-0 rounded-card px-2 py-0.5 text-xs font-medium leading-heading';

export const teamsPrimaryPillClassName =
  'inline-flex h-10 shrink-0 items-center justify-center gap-2 rounded-full bg-grey-950 px-4 text-sm font-medium leading-body text-true-white transition-colors hover:bg-grey-900 disabled:cursor-not-allowed disabled:opacity-50 dark:bg-foreground dark:text-background dark:hover:bg-foreground/90';

export const teamsDeclinePillClassName =
  'inline-flex h-10 w-full min-w-0 shrink-0 items-center justify-center rounded-full border border-grey-200 bg-true-white px-4 text-sm font-medium leading-body transition-colors hover:bg-grey-50 disabled:cursor-not-allowed whitespace-nowrap disabled:opacity-50 sm:w-auto sm:min-w-32 dark:border-border dark:bg-card dark:hover:bg-muted';

export const teamsUpgradePillClassName =
  'inline-flex h-10 w-full min-w-0 shrink-0 items-center justify-center rounded-full bg-grey-950 px-4 text-sm font-medium leading-body text-true-white transition-colors hover:bg-grey-900 disabled:cursor-not-allowed whitespace-nowrap disabled:opacity-50 sm:w-auto sm:min-w-32 dark:bg-foreground dark:text-background dark:hover:bg-foreground/90';

export const teamsHandledOutcomeClassName =
  'inline-flex shrink-0 items-center gap-1.5 rounded-full bg-success-50 px-2.5 py-1 text-xs font-medium leading-heading text-success-700';

export const teamsMemberStatusActiveClassName =
  'bg-success-50 text-success-700 dark:bg-success-background dark:text-success-high-emphasis';

export const teamsMemberStatusInactiveClassName =
  'bg-grey-100 text-grey-600 dark:bg-grey-800 dark:text-grey-300';

/** Figma 10631:5972 / 10631:5949 — 42×24 track, grey-900 on, grey-200 off. */
export const teamsSwitchClassName =
  'h-6 w-10.5 border-0 px-0.75 data-[state=checked]:bg-grey-900 data-[state=unchecked]:bg-grey-200';

/**
 * 18px white thumb, 3px from either edge. Keeps the switch's tight shadow-sm: the Figma
 * "Primary shadow/light" (0 10px 20px) spills past the 24px track and makes the off thumb
 * look off-centre on the light grey track.
 */
export const teamsSwitchThumbClassName =
  'size-4.5 translate-x-0 data-[state=checked]:translate-x-4.5';

/** Figma plan cell control is 196×36; max-w-48 (192) is the nearest scale step. */
export const teamsPlanSelectClassName =
  'inline-flex h-9 w-48 max-w-full items-center justify-between gap-2 rounded-card border border-grey-100 bg-true-white px-3.5 text-sm leading-body dark:border-border dark:bg-card';
